import Link from 'components/ui/AppLink';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { useLogger } from '../providers/logger/Logger';
import { LogLevel, LogAction } from '../providers/logger/logger-types';
import { config } from '../../config';

import { useAuth0 } from 'neon-auth0';
import { Route } from 'react-router-dom';
import { useUser, TrialState } from '../providers/UserProvider';
import { MessageView } from 'components/ui/Feedback';

const AuthenticatedRoute = ({
    permittedRoles,
    component: Component,
    ...rest
}: any): JSX.Element => {
    const { isAuthenticated } = useAuth0();
    const { trialState, hasScope } = useUser();
    const { printLog } = useLogger();

    const hasPermittedRole = permittedRoles.some(hasScope);

    if (isAuthenticated === false || !hasPermittedRole) {
        printLog(LogLevel.WARN, LogAction.Authentication, 'Invalid Route', {
            route: rest.location,
        });
        return (
            <Box sx={{ mt: 15 }}>
                <MessageView
                    styleName="error"
                    size="medium"
                    title="Access Denied"
                >
                    You don't have sufficient permissions to access this area of
                    Neon Insights
                </MessageView>
            </Box>
        );
    }

    if (trialState === TrialState.TrialExpired) {
        printLog(LogLevel.INFO, LogAction.Authentication, 'Trial expired', {
            route: rest.location,
        });
        return (
            <Box sx={{ mt: 15 }}>
                <MessageView
                    styleName="primary"
                    size="large"
                    title="Your trial has now ended"
                    primaryAction={{
                        label: 'Return to the Neon Dashboard',
                        onClick: () => {
                            window.location.href = config.landingPageUrl;
                        },
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        To continue your access to Neon Insights, please contact{' '}
                        <Link
                            sx={{ fontSize: 'inherit' }}
                            ignoreRouter
                            to="mailto:neonsupport@marex.com"
                        >
                            neonsupport@marex.com
                        </Link>
                    </Typography>
                </MessageView>
            </Box>
        );
    }

    return (
        <Route
            {...rest}
            render={(props): JSX.Element => (
                <Component {...props} customParams={rest.customProps} />
            )}
        />
    );
};

export default AuthenticatedRoute;
